import React from "react";
import styled from "styled-components";

const SubTitle = styled.div`
  font-family: "CircularStd-Book";
  font-size: 24px;
  color: #82817f;
  width: 80%;
  @media (max-width: 680px) {
    width: 100%;
    margin-bottom: 2rem;
    font-size: 16px;
  }
`;
export default ({ children }) => <SubTitle>{children}</SubTitle>;



// WEBPACK FOOTER //
// ./src/components/generic/form/service/Subtitle/index.js